var version = {
    "name":      "dativery",
    "buildDateCode": "20260401-135243",
    "buildDate": "Wed Apr 01 2026 13:52:43 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260401-135243",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;